import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material'
import React from 'react'
import CloseIcon from '@mui/icons-material/Close';

export default function SubservicePopup({handleClose,component, open,maxWidth, title}) {
  return (
    <Dialog onClose={handleClose} open={open} maxWidth={maxWidth} fullWidth>
      <DialogTitle textAlign="center">{title?title:""}    <IconButton
          edge="end"
        
          onClick={handleClose}
          aria-label="close"
          sx={{ position: "absolute", right: 15, top: 2 }}
        >
          <CloseIcon />
        </IconButton></DialogTitle>
        <DialogContent>
            {component}
        </DialogContent>
      </Dialog>
  )
}
